import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';

import { receiveError } from '../../store/actions/notificationAction';
import { receiveExportAwbs, receiveGhaAwbs, receiveGhaOrderAwbs } from '../../store/actions/awbsAction';
import { setDestinationGha } from '../../store/actions/ghaAction';
import { setDestinationPort }  from '../../store/actions/portAction';
import { updateWholeTruckCart } from '../../store/actions/truckCartAction';
import { fetchFinish, fetchPending } from '../../store/actions/fetchingAction';

import awbRemote from '../../api/awbRemote';
import cartRemote from '../../api/cartRemote';

import PrevNext from '../prevAndNext/PrevNext';
import ForwarderExport from './ForwarderExport';
import ConfirmationDialog from '../confirmation/ConfirmationDialog';
import ProcessBarContainer from '../processBar/ProcessBarContainer';
import AddAWBModalContainer from '../forwarderExport/addAWBModal/AddAWBModalContainer';

import AttachmentsContainer from '../attachments/AttachmentsContainer';
import Awb from '../../models/Awb';
import TruckCart from '../../models/TruckCart';
import ApiResponse from '../../models/ApiResponse';
import TruckCartItem from '../../models/TruckCartItem';
import ResponseError from '../../models/ResponseError';

import { AWB_SCHEMA } from '../../utils/airwayBill';
import PoDModalContainer from '../poD/PoDModalContainer';
import { AwbPartStatuses } from '../../models/AwbPart';
import { UserRoleType } from '../../models/User';

import { getAwbPartStatuses } from '../../store/actions/awbPartStatusesAction';
import ManualEntryEdit from '../../models/ManualEntryEdit';

import commonStyles from '../common/common.module.css';

interface ForwarderExportProps {
  port: string;
  gha_id: number;
  truckCart: Array<TruckCartItem>;
  awbsExport: Awb[];
  availableAwbPartStatuses: AwbPartStatuses;
  updateCart: (cart: TruckCart) => void;
  fetchFinish: () => void;
  fetchPending: () => void;
  receiveError: (error: ResponseError) => void;
  onExistAirwayBill: (error: ResponseError) => void;
  setDestinationGha: Function;
  setDestinationPort: (port: string) => void;
  onReceiveExportAwbs: Function;
  getAvailableAwbPartStatuses: Function;
  userRole: UserRoleType;
  onReceiveGhaAwbs: Function;
  ghaAwbs: Array<Awb>;
  getGhaOrderAwbs: (orderNumber: string) => void;
  manualEntryEdit: ManualEntryEdit;
};

interface ForwarderExportState {
  awb: Awb;
  code: string;
  number: string;
  version: number;
  isModalOpen: boolean;
  requestId?: string;
  didUpdates: number;
  showNextButton: boolean;
  isModalPoDOpen: boolean;
  isSyncingConfirmationOpen: boolean;
  isAwbDeletionConfirmationOpen: boolean;
  isAttachmentsDialogOpen: boolean;
  completed: boolean;
  awbNumber: string;
  sortby: string;
};

class ForwarderExportContainer extends Component <ForwarderExportProps, ForwarderExportState> {

  state = {
    isModalOpen: false,
    isModalPoDOpen: false,
    requestId: '',
    awb: AWB_SCHEMA,
    code: '',
    number: '',
    version: 0,
    didUpdates: 0,
    showNextButton: false,
    isSyncingConfirmationOpen: false,
    isAwbDeletionConfirmationOpen: false,
    isAttachmentsDialogOpen: false,
    completed: false,
    awbNumber: '',
    sortby: 'creation_date',
  };

  componentDidMount() {

    if (this.props.userRole === UserRoleType.FORWARDER) {
      this.props.onReceiveExportAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.awbNumber, this.state.sortby);

      if(this.props.availableAwbPartStatuses.import.length === 0) {
        this.props.getAvailableAwbPartStatuses();
      }
    } 
    else {

      const manualEntryEdit: ManualEntryEdit = this.props.manualEntryEdit;

      if (manualEntryEdit && manualEntryEdit.isEditMode) {

        this.props.getGhaOrderAwbs(manualEntryEdit.orderNumber); 
      } else {
  
        this.props.onReceiveGhaAwbs(true);
      }
    }
  }

  componentDidUpdate(prevProps: ForwarderExportProps) {

    const truckCartItemsLength: number = this.props.truckCart.length;

    if (truckCartItemsLength > 0 && this.state.didUpdates < 2) {
      this.showHidePreviousButton(truckCartItemsLength);
      this.setState({ didUpdates: this.state.didUpdates + 1 });
    }

    if (this.props.userRole === UserRoleType.FORWARDER) {
      const newProps: ForwarderExportProps = this.props;

      if (prevProps.port !== newProps.port || prevProps.gha_id !== newProps.gha_id) {
        this.props.onReceiveExportAwbs(newProps.port, newProps.gha_id, this.state.completed, this.state.awbNumber, this.state.sortby);
      };
    } else {

      const manualEntryEdit: ManualEntryEdit = this.props.manualEntryEdit;

      if (prevProps.ghaAwbs === this.props.ghaAwbs) { // ?????  CALLED 2 TIMES ! ???

        if (manualEntryEdit && manualEntryEdit.isEditMode) {

          this.props.getGhaOrderAwbs(manualEntryEdit.orderNumber); 
        } else {

          this.props.onReceiveGhaAwbs(true);
        }
      }
    }
  }

  handleOpenParts = (awb: Awb, requestId?: string): void => {

    this.setState({ isModalOpen: true, requestId, awb });
  };

  showCompletedAwbs = (): void => {
    const completed = !this.state.completed
    this.setState({ completed }, () => {
      this.props.onReceiveExportAwbs(this.props.port, this.props.gha_id, completed, this.state.awbNumber, this.state.sortby);
    });
  }

  onChange = (type: string, event: any): void => {
    const value = event.target.value;
    if(type === 'awb') {
      this.setState({ awbNumber: value });
    } else {
      this.setState({ sortby: value }, () => {
        this.props.onReceiveExportAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.awbNumber, this.state.sortby);
      });
    }
  }

  searchAwb = (): void => {
    this.props.onReceiveExportAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.awbNumber, this.state.sortby);
  }

  clearAwbSearch = () => {
    this.setState({ awbNumber: '' }, () => {
      this.props.onReceiveExportAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.awbNumber, this.state.sortby);
    })
  }

  handleEdit = (awbData: Awb, opt: {edited: boolean, metadata: boolean}): Promise<any> => {

    return awbRemote.editAwb(awbData, this.state.requestId, opt.metadata, true, this.props.manualEntryEdit.orderNumber).then((resp: ApiResponse<Awb>) => {

      const awb: Awb | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awb) {

        const originPort: string = awb.origin;
        const gha: number | null = awb.id_gha_org;

        if (this.props.port === originPort && this.props.gha_id === gha) {

          this.props.onReceiveExportAwbs(originPort, gha, this.state.completed, this.state.awbNumber, this.state.sortby);

        } else {
          this.props.setDestinationPort(originPort);
          this.props.setDestinationGha(gha);
        };
        this.setState({ isModalOpen: false });

        if(this.props.userRole === UserRoleType.GHA) {
          this.props.onReceiveGhaAwbs(true);
        }
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  handleSync = (code: string, number: string): void => {

    this.setState({ isSyncingConfirmationOpen: true, code, number });
  };

  syncAwb = (code?: string, number?: string): void => {

    code = code || this.state.code;
    number = number || this.state.number;

    let awbNumber: string = `${code}-${number}`;
    this.setState({ isModalOpen: false, isSyncingConfirmationOpen: false });

    this.props.fetchPending();
    awbRemote.extractAwb(awbNumber, 'export').then((resp: {awbData: Awb, requestId: string}) => {

      let { awbData, requestId } = resp;
      this.handleOpenParts(awbData, requestId);
      this.props.fetchFinish();

    }, (err) => {
      this.props.fetchFinish();
      this.props.receiveError(err);
    });
  };

  checkAirwayBillIsInTheCart = (code: string, number: string, ver: number): void => {

    const found: TruckCartItem | undefined = this.findInCart(code, number);

    if (found) {

      const error: ResponseError = {
        errorCode: '',
        longDescription: 'Airwaybill is already in your cart!'
      };

      this.props.onExistAirwayBill(error);

    } else {

      cartRemote.addExportAirwayBillToCart(code, number, ver).then((resp: ApiResponse<TruckCart>) => {

        const cart: TruckCart | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        const truckCartItemsLength: number = (cart && cart.cart) ? cart.cart.length : 0;

        if (cart) {
          this.props.updateCart(cart);
          this.showHidePreviousButton(truckCartItemsLength);
        }

        if (error) {
          this.props.receiveError(error);
        };
      });
      
    }
  }

  enableCartIcon = (code: string, number: string): boolean => {

    const foundAwb: Awb | undefined = this.findInAwb(code, number);
    const foundCart: TruckCartItem | undefined = this.findInCart(code, number);

    if (foundAwb && foundCart) {
      return foundAwb.export_parts.length !== foundCart.parts.length;
    }

    return foundCart === undefined;
  }

  findInAwb = (code: string, number: string): Awb | undefined => {

    return this.props.awbsExport.find((awbElement: Awb) => {
      return awbElement.code === code && awbElement.number === number;
    });
  };

  findInCart = (code: string, number: string): TruckCartItem | undefined => {
    
    return this.props.truckCart.find((cartElement: TruckCartItem) => {
      return cartElement.code === code && cartElement.number === number;
    });
  }
  
  handleDelete = (code: string, number: string): void => {

    this.setState({ isAwbDeletionConfirmationOpen: true, code, number });
  };

  openAttachments = (code: string, number: string, version: number): void => {
    this.setState({ isAttachmentsDialogOpen: true, code, number, version});
  };

  closeAttachments = (): void => {
    this.setState({ isAttachmentsDialogOpen: false, code: '', number: ''  });
  };

  deleteAwb = (): void => {

    awbRemote.deleteAwb(this.state.code, this.state.number).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        if( this.props.userRole === UserRoleType.FORWARDER)
          this.props.onReceiveExportAwbs(this.props.port, this.props.gha_id, this.state.completed, this.state.awbNumber, this.state.sortby);
        if(this.props.userRole === UserRoleType.GHA)
          this.props.onReceiveGhaAwbs(true);
      };

      if (error) {
        this.props.receiveError(error);
      };
      
      this.closeConfirmationDialogs();
    });
  };

  closeConfirmationDialogs = (): void => {

    this.setState({ isAwbDeletionConfirmationOpen: false, code: '', number: '' });
  };

  showHidePreviousButton = (truckCartItemsLength: number): void => {

    const show: boolean = truckCartItemsLength > 0;
    this.setState({ showNextButton: show });
  }

  handleOpenPoD = (code: string, number: string, version: number): void => {

    this.setState({ isModalPoDOpen: true, code, number, version });
  };

  handleCloseModal = (modalType: string): void => {

    if (modalType === 'import') {
      this.setState({ isModalOpen: false });
    }

    if (modalType === 'pod') {
      this.setState({ isModalPoDOpen: false, code: '', number: ''});
    }
  }

  render() {

    const isMeEditMode: boolean = this.props.manualEntryEdit.isEditMode;
    const showNextButton: boolean = this.state.showNextButton || isMeEditMode;
    const awbs: Array<Awb> = this.props.userRole === UserRoleType.FORWARDER ? this.props.awbsExport : this.props.ghaAwbs;
    const nextBtnHref: string = this.props.userRole === UserRoleType.FORWARDER ? '/truck' : (isMeEditMode ? '/manual-entry-drop-off-order' : '/manual-entry-truck');

    return (
      <Fragment>
        <div className={ commonStyles.headerDummyDiv }></div>
        <ProcessBarContainer type='export' userRole={ this.props.userRole} />
        <ForwarderExport
          awbs={ awbs }
          openParts={ this.handleOpenParts }
          enableCartIcon={ this.enableCartIcon }
          checkAirwayBillIsInTheCart={ this.checkAirwayBillIsInTheCart }
          deleteAwb={ this.handleDelete }
          handleOpenPoD={ this.handleOpenPoD }
          onSyncClick={ this.handleSync }
          openAttachments={ this.openAttachments }
          userRole={ this.props.userRole }
          completeAwbs={ this.showCompletedAwbs }
          completed={ this.state.completed }
          awbNumber={ this.state.awbNumber }
          searchAwb={ this.searchAwb }
          onChange={ this.onChange }
          sortValue={ this.state.sortby }
          clearAwb={ this.clearAwbSearch }
        />

        { showNextButton &&
          <PrevNext nextButton={ { active: true, href: `${nextBtnHref}`, animate: true } } />
        }

        { this.state.isModalOpen &&
          <AddAWBModalContainer 
            modalOpen={ this.state.isModalOpen }
            awb={ this.state.awb }
            handleSave={ this.handleEdit }
            handleSync={ this.syncAwb }
            handleCloseModal={() => { this.setState({ isModalOpen: false }) }}
            awbActionOfUpdateButton={ 'update' }
            edited={ false }
            userRole={ this.props.userRole }
        />
        }
        { this.state.isAwbDeletionConfirmationOpen && 
          <ConfirmationDialog
            open={ this.state.isAwbDeletionConfirmationOpen }
            close={ () => { this.setState({ isAwbDeletionConfirmationOpen: false }) } }
            title='Delete Confirmation'
            text='Are you sure you want to delete this airwaybill?'
            textConfirm='delete'
            confirm={ this.deleteAwb } 
            showCloseIcon={ true }

          />
        }

        { this.state.isSyncingConfirmationOpen && 
          <ConfirmationDialog
            open={ this.state.isSyncingConfirmationOpen }
            close={() => { this.setState({ isSyncingConfirmationOpen: false }) }}
            title='Sync confirmation'
            text={`Are you sure you want to sync ${this.state.code}-${this.state.number}?`}
            textConfirm='sync'
            confirm={ () => this.syncAwb() } 
            showCloseIcon={ true }
          />
        }
        { this.state.isAttachmentsDialogOpen && 
          <AttachmentsContainer
            code = { this.state.code }
            number = { this.state.number }
            process = {'export'}
            closeAttachments = { this.closeAttachments }
            refreshAwbs={ true }
            version={ this.state.version }
          />
        }
        { this.state.isModalPoDOpen && 
         <PoDModalContainer 
          isModalOpen={ this.state.isModalPoDOpen }
          handleCloseModal={ this.handleCloseModal }
          code={ this.state.code }
          number={ this.state.number }
          version={ this.state.version }
          />
        }
      </Fragment>
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    awbsExport: state.awbsExport,
    ghaAwbs: state.awbsGha,
    port: state.originPort,
    gha_id: state.originGhaId,
    truckCart: state.truckCart.cart,
    availableAwbPartStatuses: state.awbPartStatuses,
    manualEntryEdit: state.manualEntryEdit
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    updateCart: (cart: TruckCart) => dispatch(updateWholeTruckCart(cart)),
    onReceiveGhaAwbs: (isExport: boolean) => dispatch(receiveGhaAwbs(isExport)),
    fetchFinish: () => dispatch(fetchFinish()),
    fetchPending: () => dispatch(fetchPending()),
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    setDestinationGha: (gha: number) => dispatch(setDestinationGha(gha)),
    onExistAirwayBill: (error: ResponseError) => dispatch(receiveError(error)),
    setDestinationPort: (port: string) => dispatch(setDestinationPort(port)),
    onReceiveExportAwbs: (port: string, gha: number, completed: boolean, keyword: string, sort: string) => dispatch(receiveExportAwbs(port, gha, completed, keyword, sort)),
    getAvailableAwbPartStatuses: () => dispatch(getAwbPartStatuses()),
    getGhaOrderAwbs: (orderNumber: string) => dispatch(receiveGhaOrderAwbs(orderNumber))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForwarderExportContainer);
